export default __webpack_public_path__ + "static/media/prods.36a09a03.webp";